import React from 'react';
import { useDispatch } from 'react-redux';
import { gql, useMutation } from '@apollo/client';
import { flashMessage as __flashMessage } from '~/app/actions';

const withPresetActions = (Component) => {
  const PresetActions = (props) => {
    const dispatch = useDispatch();
    const flashMessage = (message, type) => dispatch(__flashMessage(message, type));

    // deleteWidgetPreset
    const [__deleteWidgetPreset] = useMutation(ACTION_DELETE_PRESET, {
      refetchQueries: ['getPresets']
    });
    const deleteWidgetPreset = (presetId) => __deleteWidgetPreset({
      variables: { presetId }
    });

    // editWidgetPreset
    const [__editWidgetPreset] = useMutation(ACTION_EDIT_PRESET, {
      refetchQueries: ['getPresets']
    });
    const editWidgetPreset = (presetId, props) => __editWidgetPreset({
      variables: { presetId, props }
    });

    // addWidgetPreset
    const [__addWidgetPreset] = useMutation(ACTION_ADD_PRESET, {
      refetchQueries: ['getPresets']
    });
    const addWidgetPreset = (preset) => __addWidgetPreset({
      variables: { preset }
    });

    return <Component
      {...props}
      {...{
        flashMessage,
        deleteWidgetPreset,
        editWidgetPreset,
        addWidgetPreset,
      }}
      />;
  };

  return PresetActions;
}

/* =============================================================================
=    GraphQL: Delete/Add/Edit Widget Presets
============================================================================= */
const ACTION_DELETE_PRESET = gql`
mutation deleteWidgetPreset($presetId: ID! ) {
  deleteWidgetPreset(presetId: $presetId) {
    status
    message
  }
}`;

const ACTION_EDIT_PRESET = gql`
mutation editWidgetPreset($presetId: ID!, $props: JSON!) {
  editWidgetPreset(presetId: $presetId, props: $props) {
    status
    message
  }
}
`;

const ACTION_ADD_PRESET = gql`
mutation addWidgetPreset($preset: AddPresetInput!){
  addWidgetPreset(preset: $preset){
    _id
  }
}
`;

export default withPresetActions;
